"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import * as Aria from 'react-aria-components';
import { TunnelProvider, TunnelExit } from '@mittwald/react-tunnel';
import { Button } from '../Button/Button.mjs';
import 'react';
import '@tabler/icons-react';
import '../Icon/Icon.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconChevronDown } from '../Icon/components/icons/IconChevronDown.mjs';
import { Options } from '../Options/Options.mjs';
import '../../lib/propsContext/propsContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import clsx from 'clsx';
import styles from './ComboBox.module.scss.mjs';
import formFieldStyles from '../FormField/FormField.module.scss.mjs';
import locales from '../../../../_virtual/_.locale.json@51dcf4944c990e2cbe26472300dae78d.mjs';
import { useLocalizedStringFormatter } from 'react-aria';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import 'mobx';
import { useOverlayController } from '../../lib/controller/overlay/useOverlayController.mjs';

const ComboBox = flowComponent("ComboBox", (props) => {
  const {
    children,
    className,
    menuTrigger = "focus",
    onChange = () => {
    },
    onSelectionChange = () => {
    },
    controller: controllerFromProps,
    placeholder,
    ref,
    renderEmptyState,
    ...rest
  } = props;
  const stringFormatter = useLocalizedStringFormatter(locales);
  const rootClassName = clsx(
    styles.comboBox,
    formFieldStyles.formField,
    className
  );
  const propsContext = {
    Label: {
      className: formFieldStyles.label,
      optional: !props.isRequired
    },
    FieldDescription: {
      className: formFieldStyles.fieldDescription
    },
    FieldError: {
      className: formFieldStyles.customFieldError
    },
    Option: {
      tunnelId: "options"
    }
  };
  const handleOnSelectionChange = (key) => {
    onChange(String(key));
    onSelectionChange(key);
  };
  const controllerFromContext = useOverlayController("ComboBox", {
    reuseControllerFromContext: true
  });
  const controller = controllerFromProps ?? controllerFromContext;
  return /* @__PURE__ */ jsx(
    Aria.ComboBox,
    {
      ref,
      menuTrigger,
      className: rootClassName,
      ...rest,
      onSelectionChange: handleOnSelectionChange,
      onOpenChange: (isOpen) => controller.setOpen(isOpen),
      children: /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children: /* @__PURE__ */ jsxs(TunnelProvider, { children: [
        /* @__PURE__ */ jsxs("div", { className: styles.input, children: [
          /* @__PURE__ */ jsx(Aria.Input, { placeholder }),
          /* @__PURE__ */ jsx(
            Button,
            {
              className: styles.toggle,
              "aria-label": stringFormatter.format("comboBox.showOptions"),
              variant: "plain",
              color: "secondary",
              children: /* @__PURE__ */ jsx(IconChevronDown, {})
            }
          )
        ] }),
        children,
        /* @__PURE__ */ jsx(Options, { controller, renderEmptyState, children: /* @__PURE__ */ jsx(TunnelExit, { id: "options" }) })
      ] }) })
    }
  );
});

export { ComboBox, ComboBox as default };
//# sourceMappingURL=ComboBox.mjs.map
